<template>
  <div class="embed-section">
    <div class="embed-wrapper">
      <div class="input-container">
        <input
          v-model="link"
          spellcheck="false"
          class="link-input"
          placeholder="Paste YouTube video link..."
          @keyup.enter="setElementCover"
        />
        <div class="options-container">
          <div class="checkbox">
            <input id="autoplay-option" v-model="autoplay" type="checkbox" />
            <label for="autoplay-option">Autoplay</label>
          </div>
          <question-tip
            text="Due to browsers restrictions, video<br/>may not autoplay till player interacts<br/>with the Play Mode's page"
            :html="true"
          />
          <div class="checkbox">
            <input
              id="controls-option"
              v-model="showControls"
              type="checkbox"
            />
            <label for="controls-option">Show Controls</label>
          </div>
        </div>
        <button class="button" @click="setElementCover">
          Embed Video
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import QuestionTip from '../QuestionTip.vue';
import { getYoutubeOEmbed } from '../../../utils.js';

export default {
  components: { QuestionTip },
  props: {
    assetReference: {
      type: Object,
      default: null,
    },
    onSelect: {
      type: Function,
      default: () => {},
    },
  },

  data() {
    return {
      link: '',
      autoplay: true,
      showControls: false,
    };
  },

  computed: {},

  mounted() {
    this.link = this.assetReference?.url;
    this.autoplay =
      this.assetReference?.autoplay === undefined
        ? true
        : this.assetReference.autoplay;
    this.showControls =
      this.assetReference?.showControls === undefined
        ? false
        : this.assetReference.showControls;
  },

  methods: {
    ...mapActions('application/notifications', ['createInfo', 'createError']),
    setElementCover() {
      if (!this.link) {
        this.createError({ text: 'The input field is empty' });
        return;
      }
      const ytUrl = new URL(this.link);

      const validDomains = [
        'youtube.com',
        'www.youtube.com',
        'youtu.be',
        'www.youtu.be',
      ];
      if (!validDomains.includes(ytUrl.host)) {
        this.createError({ text: 'We currently only accept YouTube videos' });
        return;
      }

      getYoutubeOEmbed(this.link)
        .then(response => {
          this.onSelect(
            {
              type: 'youtube',
              url: this.link,
              autoplay: this.autoplay,
              showControls: this.showControls,
            },
            true
          );
        })
        .catch(err => {
          if (err.response.status === 400 || err.response.status === 404) {
            this.createError({ text: 'The YouTube video was not found' });
          }
          console.error(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.embed-section {
  padding: 15px;
  .embed-wrapper {
    display: flex;
    margin: 0 0 8px 0;

    .input-container {
      flex: 3;
      position: relative;
      margin: 0 15px 0 0;
      .link-input {
        width: 100%;
        height: 40px;
        background: #141616;
        border: none;
        border-radius: 4px;
        padding: 10px 14px 8px 14px;
        color: #fff;
        &:focus {
          background: #0a0a0a;
        }
        margin-bottom: 15px;
      }

      .options-container {
        display: flex;
        margin-bottom: 15px;

        .checkbox {
          margin-right: 10px;

          input[type='checkbox'] {
            &:checked + label:after {
              left: 5px;
              top: 10px;
            }
            & + label {
              font-size: 14px;
            }
          }

          input[type='checkbox'] {
            position: absolute;
            opacity: 0;

            & + label {
              cursor: pointer;
              position: relative;
              border-radius: 3px;
            }

            & + label:before {
              content: '';
              margin-right: 10px;
              display: inline-block;
              vertical-align: text-top;
              width: 20px;
              height: 20px;
              background: #2c3233;
              border-radius: 3px;
              border: 1px solid #696d6d;
            }

            &:checked + label:before {
              background: #db841e;
              border: 1px solid transparent;
            }

            &:checked + label:after {
              content: '';
              position: absolute;
              background: white;
              width: 2px;
              height: 2px;
              box-shadow: 2px 0 0 white, 4px 0 0 white, 4px -2px 0 white,
                4px -4px 0 white, 4px -6px 0 white, 4px -8px 0 white;
              transform: rotate(45deg);
            }
          }
        }

        .tip {
          margin: 0 15px 0 0;
        }
      }

      .button {
        padding: 0 14px;
        flex: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 40px;
        border-radius: 3px;
        width: 100%;
        border: none;
        color: #fff;
        background: #db841e;
        cursor: pointer;
        margin: 0;
        text-align: center;
        position: relative;
        -webkit-transition: background 0.25s;
        transition: background 0.25s;
        font-size: 14px;
        font-weight: 600;
        white-space: nowrap;
      }
    }
  }
}
</style>
